module.exports = __webpack_public_path__ + "assets/img/Interiors-Australia-Landing-Page.6350e5ee.jpg";